import React, { useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import "../styles/MobileLogin.css";
import { useNavigate, useLocation } from "react-router-dom";

const LoginScreen = () => {
  const {
    handleLogin,
    loading,
    setPassword,
    password,
    phoneNumber,
    setPhoneNumber,
  } = useContext(AuthContext);

  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await handleLogin();
    if (success) {
      const { intendedShortId, intendedBookingId } = location.state || {};
      if (intendedShortId || intendedBookingId) {
        navigate("/", { state: { bookingCode: intendedShortId || intendedBookingId } });
      } else {
        navigate("/");
      }
    }
  };

  return (
    <div className="login-container">
      <div className="login-image-top"></div>
      <div className="login-box">
        <h1>LOGIN TO HUNTEXLOTTO</h1>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="text"
              placeholder="Phone Number or Email"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
            />
          </div>
          <div
            className="input-group"
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
            }}
          >
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ width: "100%", paddingRight: "60px" }}
            />
            <button
              type="button"
              style={{
                position: "absolute",
                left: "44%",
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                cursor: "pointer",
                color: "#2563eb",
                fontSize: "0.9em",
                padding: 0,
              }}
              onClick={() => setShowPassword((prev) => !prev)}
              tabIndex={-1}
            >
              {showPassword ? "Hide" : "Show"}
            </button>
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
        <div className="links" onClick={() => navigate('/password-reset')}style={{ marginTop: 16 }}>
          <a href="#">Forgot Password?</a>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;